import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateLocation = createAsyncThunk(
  "updateLocation",
  async ({ id, data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.patch(
      `location/update?id=${id}`,
      data,
      config
    );

    form.resetFields();
    message.success("Location successfully updated!");
    history("/app/organization/location");
    return response.data;
  }
);

const locationUpdateSlice = createSlice({
  name: "locationUpdate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateLocation.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateLocation.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateLocation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default locationUpdateSlice.reducer;